import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../../redux/hooks";
import {
  AuthStatus,
  getAuthStatus,
  setAuthState,
  setAuthToken,
} from "../../redux/reducers/auth";
import { useQuery } from "../../utils/GeneralUtils";

import { postVerificationRequest } from '../../services/api/user/postVerificationRequest';

import styles from "./p-register.module.scss";
import RegistComplete from "./RegistComplete";
import RegistVerificationForm from "./RegistVerificationForm";

const enum RegistVerifiyState {
  Loading,
  Failed,
  Ready,
  Complete,
}

const VerificationPage: React.FC = () => {
  const query = useQuery();

  const auth_status = useAppSelector(getAuthStatus);
  const dispatch = useAppDispatch();
  const [verifyCode, setVerifyCode] = useState("");
  const [verifyState, setVerifyState] = useState(RegistVerifiyState.Ready);
  const [email, setEmail] = useState("");

  useEffect(() => {
    const query_email = query.get("email");
    const query_verify_code = query.get("code");

    if (query_email) {
      setEmail(query_email);
    }

    if (query_verify_code) {
      setVerifyCode(query_verify_code);
    }
  }, []);

  function handleVerifyChange(value: string) {
    setVerifyCode(value);
  }

  async function handleVerifySubmit() {
    if (verifyCode !== "" && email !== "") {
      const resp = await postVerificationRequest(verifyCode, email);

      if (resp !== null && typeof resp == "string") {
        localStorage.removeItem("sonic_reg_state");
        setVerifyState(RegistVerifiyState.Complete);
        setTimeout(() => {
          dispatch(setAuthState(AuthStatus.Authenticated));
          dispatch(setAuthToken(resp));
        }, 3000);
      } else {
        setVerifyState(RegistVerifiyState.Failed);
      }
    }
  }

  if (auth_status !== AuthStatus.Authenticated) {
    return (
      <div className={styles["p-register__container"]}>
        {verifyState == RegistVerifiyState.Complete ? (
          <RegistComplete />
        ) : (
          <RegistVerificationForm
            input_handler={handleVerifyChange}
            submit_handler={handleVerifySubmit}
            verification_state={verifyState}
            code={verifyCode}
          />
        )}
      </div>
    );
  } else {
    return (
      <Navigate
        to={{ pathname: "/mypage", search: "?showTutorial=true" }}
        replace
      />
    );
  }
};

export default VerificationPage;
